<template>
  <ob-admin-section
    type="indicatori"
    :xlsx="true"
    :xlsxdown="true"
    :confirm-value="confirm.dialog"
    has-perioade
    import-headers-btn
    @confirmed="_cbConfirmed"
    ref="adminSection">
    <template slot="section-title">Sectiune Rapoarte si Indicatori</template>
    <template slot="toolbar-title">Baza de date Rapoarte si Indicatori</template>
    <template slot="fab">
      <v-btn
        absolute
        dark
        fab
        bottom
        right
        color="accent"
        class="ob-speed-dial"
        @click="_cbOpenUploadDialog">
        <v-icon>mdi-file-upload</v-icon>
      </v-btn>
    </template>
    <template slot="dialogs">
      <ob-dialog :value="bulkUploadDialog" :max-width="500" @close="_cbCloseDialog" key="bulkUploadDialog">
        <template slot="title">
          Import in masa pentru toate tab-urile din perioada selectata
        </template>
        <template slot="content">
          <v-alert :value="true" type="info" class="mb-2">Procesul este automatizat. Permiteti finalizarea.</v-alert>
          <form ref="bulkUploadForm">
            <input type="file" ref="filesInput">
            <br>
            <v-checkbox
              v-for="tab in tabs"
              :key="tab._id"
              v-model="bulkUploadTabs"
              :label="tab.label"
              :value="tab._id"
              hide-details>
            </v-checkbox>
            <v-btn @click="selectAllTabs" color="primary" flat>
              (De)selecteaza toate tab-urile
            </v-btn>
          </form>
        </template>
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="_cbCloseDialog">Anulare</v-btn>
          <v-btn flat color="primary" @click="_cbStartUpload">Incarcare</v-btn>
        </template>
      </ob-dialog>
    </template>
  </ob-admin-section>
</template>

<script>
import AdminSection from '@/components/AdminSection'
import Dialog from '@/components/Dialog'

export default {
  name: 'indicatori',
  components: {
    'ob-admin-section': AdminSection,
    'ob-dialog': Dialog
  },
  data: () => ({
    type: 'indicatori',
    fab: null,
    confirm: {
      dialog: false,
      callback: null
    },
    bulkUploadDialog: false,
    bulkUploadTabs: []
  }),
  computed: {
    tabs () {
      return this.$store.getters[`${this.type}/tabs`]
    },
    selectedTab () {
      return this.$store.getters[`${this.type}/selectedTab`]
    },
    selectedTabID () {
      return this.$store.getters[`${this.type}/selectedTabID`]
    }
  },
  methods: {
    _cbConfirmed (value) {
      if (value && this.confirm.callback) this[this.confirm.callback]()
      this.confirm.dialog = false
      this.confirm.callback = null
    },
    selectAllTabs () {
      this.bulkUploadTabs = this.bulkUploadTabs.length ? [] : [...this.tabs].map(tab => tab._id)
    },
    _cbOpenUploadDialog () {
      this.bulkUploadDialog = true
    },
    _cbCloseDialog () {
      this.bulkUploadDialog = false
      this.resetBulkUploadForm()
    },
    resetBulkUploadForm () {
      this.$refs.bulkUploadForm.reset()
      this.bulkUploadTabs = []
    },
    async _cbStartUpload () {
      // automating old code, haha
      try {
        const file = this.$refs.filesInput.cloneNode().files[0]
        const tabs = [...this.bulkUploadTabs]
        this._cbCloseDialog()

        // cycle through tabs
        // set the tab by triggering this._cbSelectTab(tab._id)
        // trigger this.processFile(file)
        // wait for the props dialog to pop up (this.upload.props.dialog = true)
        // trigger this._cbCloseUploadPropsDialog(true)
        // wait for the props dialog to close (this.upload.props.dialog = false)

        for (const tab of tabs) {
          this.$refs.adminSection._cbSelectTab(tab)
          // console.log('waiting for tab: ', tab)
          await this.waitForTab(tab)
          // console.log('uploading file')
          this.$refs.adminSection.processFile(file)
          await this.waitForDialog(true)
          // console.log('accepting upload')
          this.$refs.adminSection._cbCloseUploadPropsDialog(true)
          // console.log('closing upload dialog')
          await this.waitForDialog(false)
          // console.log('tab finished')
        }

        this.bulkUploadDialog = false
        this.resetBulkUploadForm()
      } catch (err) {
        console.log(err)
      }
    },
    async waitForTab (tab) {
      return new Promise(resolve => {
        if (this.$refs.adminSection.selectedTabID === tab) {
          resolve()
        }
        const intewrvalId = setInterval(() => {
          if (this.$refs.adminSection.selectedTabID === tab) {
            clearInterval(intewrvalId)
            resolve()
          }
        }, 500)
      })
    },
    async waitForDialog (state) {
      return new Promise(resolve => {
        if (state === this.$refs.adminSection.upload.props.dialog) {
          resolve()
        }
        const intewrvalId = setInterval(() => {
          if (state === this.$refs.adminSection.upload.props.dialog) {
            clearInterval(intewrvalId)
            resolve()
          }
        }, 500)
      })
    }
  },
  created () {
    this.$store.dispatch('indicatori/setEventWatchers')
    this.$store.dispatch('indicatori/fetchHeaders')
    this.$store.dispatch('indicatori/fetchItems')
    this.$store.dispatch('indicatori/fetchPerioadeTabs')
  }
}
</script>

<style>

</style>
